import { render } from "./EditPermission.vue?vue&type=template&id=0f76f038"
import script from "./EditPermission.vue?vue&type=script&lang=js"
export * from "./EditPermission.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__